import { render } from "./WaitingTicket.vue?vue&type=template&id=61af2d00&scoped=true&ts=true"
import script from "./WaitingTicket.vue?vue&type=script&lang=ts"
export * from "./WaitingTicket.vue?vue&type=script&lang=ts"

import "./WaitingTicket.vue?vue&type=style&index=0&id=61af2d00&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61af2d00"]])

export default __exports__